import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

export interface BreadcrumbItem {
  name: string;
  href?: string;
  current?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb = ({ items, className = '' }: BreadcrumbProps) => {
  return (
    <nav className={`flex ${className}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1 text-sm text-m2-on-surface-variant">
        <li>
          <Link
            to="/"
            className="text-m2-outline hover:text-m2-on-surface-variant transition-colors"
            aria-label="Home"
          >
            <HomeIcon className="h-4 w-4" />
          </Link>
        </li>
        
        {items.map((item) => (
          <li key={item.name} className="flex items-center">
            <ChevronRightIcon className="h-4 w-4 text-m2-outline mx-2" />
            
            {item.href && !item.current ? (
              <Link
                to={item.href}
                className="text-m2-on-surface-variant hover:text-m2-on-surface font-medium transition-colors"
              >
                {item.name}
              </Link>
            ) : (
              <span 
                className={`${
                  item.current 
                    ? 'text-m2-on-surface font-medium' 
                    : 'text-m2-on-surface-variant'
                } truncate`}
                aria-current={item.current ? 'page' : undefined}
              >
                {item.name}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;